import "core-js/modules/es6.regexp.search";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/*专题-优惠
 * <component-topic-offer :is-promoter="promoter.isPromoter" :coupon-detail="couponDetail"></component-topic-offer>
 */
import ComponentCouponReceive from "./coupon_receive.vue";
import { isIos, isYkzMiniprogram, isYkzAlipayMiniprogram, isOtherBrowsers } from "@ykz/ykz-util/platform";
import databus, { Origins } from "@ykz/ykz-http/core";
export default {
  name: "topic_offer",
  data: function data() {
    return {
      fxbInviteCode: getUrlParams("fxbInviteCode") || "",
      weChatId: getUrlParams("weChatId") || window.weChatId,
      goodId: getUrlParams("goodId") || "",
      //商品id
      orderNo: getUrlParams("orderNo") || "",
      //订单号
      channel: getUrlParams("channel") || "",
      //详情页跳转来源参数
      isAPP: window.mobileEnv == "app" ? true : false,
      //是否在云客赞app打开页面
      isReviewing: ykzApp.isIOSReviewing(),
      //iOS审核判断
      isOtherBrowser: isOtherBrowsers(),
      //除微信、app外的第三方浏览器打开页面
      isMini: isYkzMiniprogram(),
      //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(),
      isShop: sessionStorage.getItem("session_isShop") || "",
      //店铺模式
      isIos: isIos(),
      //设备系统
      loadTopicBox: false,
      //渲染专题弹框
      showTopicBox: false,
      //显示专题弹框
      topicBoxSlideDown: true,
      //专题弹框滑下状态
      loadRuleDescription: false,
      //渲染限购退款规则弹框
      showRuleDescription: false,
      //限购退款规则弹框
      ruleSlideDown: true,
      //限购退款规则弹框滑下状态
      //showBankRule: false, //银行卡活动规则弹框

      topicList: [],
      //专题列表
      hmsTopic: null,
      // hms 专题
      couponList: [],
      //已领的券号列表
      couponTicketExpand: false,
      //现金券是否展开，默认false
      unionPayCopyWriting: "",
      //银联支付文案
      coin: {},
      //用户的红包相关对象
      hasCoupon: false,
      //是否有现金券
      coupondata: {} //新人专享券文案数据,
    };
  },

  props: {
    isPromoter: {},
    couponDetail: {},
    useCoupon: {},
    isRateplan: {},
    useCloudCoin: {},
    isMultipleDetails: {},
    hasCommission: Boolean
  },
  computed: {
    // 标签
    // labelSwitch() {
    //   try {
    //     const labelObj =
    //       (this.couponDetail && this.couponDetail.labelSwitch) || {};
    //     return {
    //       labelAddString: labelObj.labelAddString || "",
    //       labelBookString: labelObj.labelBookString || "",
    //       labelEffectString: labelObj.labelEffectString || "",
    //       labelRefundString: labelObj.labelRefundString || "",
    //       labelReserveString: labelObj.labelReserveString || "",
    //       labelTicketString: labelObj.labelTicketString || "",
    //     };
    //   } catch (error) {
    //     consol.error(error);
    //   }
    // },
  },
  watch: {
    showTopicBox: function showTopicBox(val) {
      this.setOverflow(val);
    },
    showRuleDescription: function showRuleDescription(val) {
      this.setOverflow(val);
    }
    /*showBankRule: function(val) {
        	this.setOverflow(val);
        }*/
  },

  components: {
    ComponentCouponReceive: ComponentCouponReceive
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    console.log("ycf组件初始化：topic_offer");
    window.componentCenter.topicOffer = this;
    !this.orderNo && !this.isReviewing && !this.isOtherBrowser && !this.isShop && this.getPageInfoByProduct();
    //!this.orderNo && !this.isReviewing && this.getCouponsByGoods();
    //!this.orderNo && this.getUnionPaySetting();
    !this.orderNo && !this.isReviewing && !this.isOtherBrowser && !this.isShop && this.getUserCoinInfo();

    //新人专区跳转过来，需要显示新人领券弹框
    if (!this.orderNo && this.$refs.newComer) {
      var that = this;
      this.$refs.newComer.$on("coupondata", function (val) {
        that.coupondata = val || {};
      });
      this.$refs.newComer.$on("receive", function (val) {
        that.coupondata = {}; //若已领取新人专享券，要隐藏新人专享券一栏
      });
    }
  },

  methods: {
    //滚动到指定位置，target目标元素名称(String类型)，scroll滚动元素的名称(String类型)，offset偏移量(int类型)
    scrollOffsetTop: function scrollOffsetTop(target, scroll, offset) {
      this.$parent && this.$parent.scrollOffsetTop && this.$parent.scrollOffsetTop(target, scroll, offset);
    },
    //兼容ios系统的overflow对z-index层级关系的影响
    setOverflow: function setOverflow(val) {
      if (val) {
        $(".scroll-area").css("overflow-y", "hidden");
      } else {
        $(".scroll-area").css("overflow-y", "auto");
      }
    },
    //向上滑动显示专题弹框
    slideUpTopicBox: function slideUpTopicBox() {
      if (this.topicList.length > 1) {
        this.loadTopicBox = true;
        this.$nextTick(function () {
          this.showTopicBox = true;
          var that = this;
          setTimeout(function () {
            that.topicBoxSlideDown = false;
            location.hash != "#topic" && (location.hash = "topic");
          }, 30);
        });
      } else {
        this.goTopicIndexPage(this.topicList[0]);
      }
    },
    //向下滑动隐藏专题弹框
    slideDownTopicBox: function slideDownTopicBox() {
      this.topicBoxSlideDown = true;
      var that = this;
      setTimeout(function () {
        that.showTopicBox = false;
        location.hash == "#topic" && history.go(-1);
      }, 300);
    },
    //向上滑动显示规则弹框
    slideUpRule: function slideUpRule() {
      if (location.href.search(/index\/specialDetails/) != -1) {
        this.loadRuleDescription = true;
        this.$nextTick(function () {
          var that = this;
          that.showRuleDescription = true;
          setTimeout(function () {
            that.ruleSlideDown = false;
            location.hash != "#ruleDescription" && (location.hash = "ruleDescription");
          }, 30);
        });
      } else {
        this.scrollOffsetTop(".purchase-notes");
      }
    },
    //向下滑动隐藏规则弹框
    slideDownRule: function slideDownRule() {
      var that = this;
      that.ruleSlideDown = true;
      setTimeout(function () {
        that.showRuleDescription = false;
        location.hash == "#ruleDescription" && history.go(-1);
      }, 300);
    },
    //跳转到专题页
    goTopicIndexPage: function goTopicIndexPage(topic) {
      window.location.href = "/front/topic/topicIndex?weChatId=" + this.weChatId + "&topicId=" + topic.topicId + "&topicFrom=detail";
    },
    //跳转到 hms 专题页
    onClickHmsTopic: function onClickHmsTopic() {
      location.href = this.hmsTopic.url;
    },
    //显示新人专享券弹框
    showUserCoupon: function showUserCoupon() {
      this.$refs.newComer && this.$refs.newComer.showUserCooupon();
    },
    //展开现金券
    /*expandCouponTicket: function() {
        	if(Math.abs(this.multi_height - this.single_height) <= 5) {
    return;
        	}
        	this.couponTicketExpand = !this.couponTicketExpand;
        	if(this.couponTicketExpand) {
    $(".coupon-list").css("height", this.multi_height + "px");
        	} else {
    $(".coupon-list").css("height", this.single_height + "px");
        	}
        },*/

    //获取专场活动
    getSpecialActivity: function getSpecialActivity() {
      var that = this;
      databus({
        url: "apiv2/topic/topicList",
        type: "get",
        data: {
          productId: this.goodId
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.topicList = res.content.topicList || [];
          }
        }
      });
    },
    //获取 hms专题
    getPageInfoByProduct: function getPageInfoByProduct() {
      var _this = this;
      databus({
        url: "api/page/getPageInfoByProduct",
        type: "get",
        origin: Origins.API_HMS,
        data: {
          goodsId: this.goodId
        },
        success: function success(res) {
          if (res.code === 1000) {
            _this.hmsTopic = res.content;
          }
          if (!_this.hmsTopic) {
            _this.getSpecialActivity(); // hms专题不存在，获取原有的专题列表
          }
        }
      });
    },

    //获取用户红包数量
    getUserCoinInfo: function getUserCoinInfo() {
      var that = this;
      databus({
        url: "/api/yuncoin/getUserCoinInfo",
        type: "get",
        origin: Origins.API_ACT,
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.coin = res.content || {};
          }
        }
      });
    },
    //阿拉伯数字–>中文汉字
    SectionToChinese: function SectionToChinese(section) {
      var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var chnUnitChar = ["", "十", "百", "千"];
      var strIns = "",
        chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    newAnchorPoint: function newAnchorPoint(event_id, event_label) {
      try {
        // 先从缓存中读取，如果缓存没有，则调用接口获取所需数据
        var userInfo = JSON.parse(localStorage.getItem("globalUserLocationInfo")) || JSON.parse(sessionStorage.getItem("globalUserLocationInfo")) || {};
        var promoterIdentity = -1;
        var location = JSON.parse(localStorage.getItem("shopping_mall_city")) || {};
        if (userInfo && window.promoterStatusData && location) {
          if (window.promoterStatusData.type == "2") {
            promoterIdentity = "企业";
          }
          if (window.promoterStatusData.type == "1") {
            promoterIdentity = window.promoterStatusData.isExcellence ? "优秀" : "普通";
          }
          var kv = {
            is_promoter: window.promoterStatusData.isPopularizer ? 1 : 0,
            open_id: window.openId,
            promoter_id: window.promoterStatusData.promoterId || -1,
            home_page_location: location.districtName || location.cityName,
            GPS_province: userInfo.province,
            GPS_city: userInfo.city,
            platfrom: this.isMini ? "wxMini" : this.isAlipayMini ? "alipayMini" : "h5",
            promoter_level: window.promoterStatusData.memberLevel || -1,
            promoter_identity: promoterIdentity
          };
          window.TDAPP.onEvent(event_id, event_label, kv);
        } else {
          // 通过接口后去
        }
      } catch (error) {
        console.log("数据获取异常");
      }
    },
    //大数据锚点
    reportUserAnchors: function reportUserAnchors(event_id, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: event_id,
        event_content: {
          item_id: this.goodId
        }
      }).always(callback);
    }
  }
};